import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ProductBoxEffects } from 'app/state/product-boxes/product-box.effects';
import { productBoxFeature } from 'app/state/product-boxes/product-box.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(productBoxFeature), EffectsModule.forFeature([ProductBoxEffects])],
})
export class ProductBoxStateModule {}
